import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { signInUrl } from './return-url';

/**
 * Accès au paiement : compte connecté, ou commande invitée avec jeton dans l'URL.
 */
export const orderPaymentGuard: CanActivateFn = (route, state) => {
  if (inject(AuthService).isAuthenticated()) {
    return true;
  }
  const token = route.queryParamMap.get('jeton');
  const orderId = route.queryParamMap.get('orderId');
  if (token && orderId) {
    return true;
  }
  return inject(Router).parseUrl(signInUrl(state.url));
};
